import { render, staticRenderFns } from "./jiagecaijiNew.vue?vue&type=template&id=4ca61eb2&scoped=true"
import script from "./jiagecaijiNew.js?vue&type=script&lang=js&external"
export * from "./jiagecaijiNew.js?vue&type=script&lang=js&external"
import style0 from "./jiagecaijiNew.scss?vue&type=style&index=0&id=4ca61eb2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca61eb2",
  null
  
)

export default component.exports